import "react-responsive-modal/styles.css";
import { Modal, ModalProps } from "react-responsive-modal";
import React from "react";

type Props = ModalProps & {
  rounded?: boolean;
};

export const ResponsiveModal = (props: Props) => {
  return (
    <Modal
      {...props}
      styles={{
        modal: {
          borderRadius: props.rounded ? "8px" : undefined,
        },
      }}
    />
  );
};
